'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/axios/lib/cancel/isCancel.js
// module id = m4Kp
// module chunks = 0